import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { Option } from '../../../core/types';
import Button from '../../ui/Button';
import Modal from '../../ui/Modal';
import RadioGroup from '../../ui/RadioGroup';
import useInjectScript from './useInjectScript';

const FollowUpButton = styled(Button).attrs(() => ({
  variant: 'primary',
  size: 'medium',
}))`
  vertical-align: top;
  transform: rotate(90deg);
  position: fixed;
  bottom: 350px;
  right: -74px;
  z-index: 9999;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0 0;
`;

const StyledButton = styled(Button)`
  margin: 0 20px;
`;

const issueTypes = [
  { value: '06f3b57f', label: 'Clinical Support' },
  { value: '7d482563', label: 'Complaint' },
  { value: '9a5eb018', label: 'Fax Medical Report' },
  { value: 'b4685923', label: 'Mail CD' },
  { value: 'c1512268', label: 'Mail USB' },
  { value: '27fc7f0e', label: 'MIF Incomplete' },
  { value: '3592c8ad', label: 'Non-Clinical Support' },
  { value: '9744aa3e', label: 'Schedule Hold NP Call' },
  { value: '6bdc82d4', label: 'Schedule NP Call' },
  { value: 'b623c5d9', label: 'Requisition' },
  { value: '390f13d3', label: 'NP Consult' },
  { value: 'ac1e7bc7', label: 'Online Booking' },
  { value: 'd3ba1337', label: 'Influencer Prospect' },
  { value: 'aec102d4', label: 'Investor Prospect' },
  { value: '0b1d68f8', label: 'Journalist Follow Up' },
  { value: '13933372', label: 'Enterprise Prospect' },
  { value: '2b7b6452', label: 'Physician Prospect' },
];

const IssueButton = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedContainerId, setSelectedContainerId] = useState('');
  useInjectScript(selectedContainerId);

  const handleShowModal = useCallback(() => {
    setSelectedContainerId('');
    setShowPopup(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowPopup(false);
  }, []);

  const handleChange = useCallback((value: string) => {
    setSelectedContainerId(value);
  }, []);

  return (
    <React.Fragment>
      <FollowUpButton onClick={handleShowModal}>Follow Up Task</FollowUpButton>

      {showPopup && (
        <Modal title="Issue Type" onClose={handleCloseModal}>
          <RadioGroup
            name="issueType"
            title=""
            initialValue={''}
            onChange={handleChange}
            position="vertical"
            labelSize="large"
            column={3}
          >
            {issueTypes.map((option: Option, index: number) => (
              <RadioGroup.Input
                id={`${option.value}-${index}`}
                disabled={false}
                key={option.value}
                label={option.label}
                value={option.value}
              />
            ))}
          </RadioGroup>

          <ButtonsWrapper>
            <StyledButton
              variant="primary"
              size={'medium'}
              onClick={handleCloseModal}
              id="continue"
              disabled={!selectedContainerId}
            >
              {'Continue'}
            </StyledButton>
          </ButtonsWrapper>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default IssueButton;
